import { IAvailableContacts, IPromoInfoSchema } from '../../../types/promo';

interface IGetAuthorNameParams {
  promo: IPromoInfoSchema;
  avaliableContacts: IAvailableContacts;
}

export const getAuthorName = ({ promo, avaliableContacts }: IGetAuthorNameParams): string | null | undefined => {
  const cianMortgage = promo.promoType === 'cianMortgage';

  if (cianMortgage) {
    return 'Циан.Ипотека';
  }

  return avaliableContacts.builders.length + avaliableContacts.sellers.length > 1 ? null : promo.authorName;
};
